<template>
  <div
    v-if="data"
    class="basic_wrap"
    :class="selectedCount() > 0 ? 'has-bet-sheet' : ''"
  >
    <div class="red_top_bg">
      <van-icon
        name="arrow-left"
        class="page-back"
        @click="$router.push('/user')"
      />
    </div>

    <div class="product">
      <div class="period-card">
        <div class="period-row">
          <div class="period-info">
            <div class="period-label">
              {{ $t('pro2.currentPeriod') }}
            </div>
            <div class="period-status">
              <strong>{{ periodCode() }}</strong>
              <span> {{ $t('pro2.bettingInProgress') }}</span>
            </div>
            <div class="period-time">
              <van-count-down
                :time="data && data.time ? data.time * 1000 : 0"
                @finish="finish"
              >
                <template #default="timeData">
                  {{ timeData.minutes < 10 ? "0" + timeData.minutes : timeData.minutes }}:{{ timeData.seconds < 10 ? "0" + timeData.seconds : timeData.seconds }}
                </template>
              </van-count-down>
            </div>
          </div>
          <div
            class="period-menu"
            @click="$router.push('/order')"
          >
            <span />
            <span />
            <span />
          </div>
        </div>
        <div class="period-bottom">
          <div><strong>{{ periodCode() }}</strong> {{ $t('pro2.lotteryDraw') }}</div>
          <div
            class="history-toggle"
            @click="toggleHistory"
          >
            {{ $t('pro2.historical') }}
            <van-icon :name="historyOpen ? 'arrow-up' : 'arrow-down'" />
          </div>
        </div>
      </div>

      <div
        v-if="historyOpen"
        class="history-board"
      >
        <div class="history-head">
          <div>{{ $t('pro2.ratingCode') }}</div>
          <div>{{ $t('pro2.rankingResults') }}</div>
        </div>
        <div
          v-for="(item, index) in historyList()"
          :key="index"
          class="history-row"
        >
          <div>{{ item.code }}</div>
          <div>
            <span>{{ item.first }}</span>
            <span>{{ item.second }}</span>
          </div>
        </div>
      </div>

      <div
        v-if="!historyOpen"
        class="main"
      >
        <div
          caizhong="A_XJK3"
          class="com-k3selector"
        >
          <div class="MethodWrap">
            <div class="MethodTitle">
              {{ $t('pro2.votingoptions') }}
            </div>
            <div class="Method Method0 method_themeDZ5">
              <ul v-if="data">
                <li
                  class="selit vote-card vote-card-rose"
                  :class="da == 1 ? 'checked' : ''"
                  :style="optionBg(data.p1)"
                  @click="da == 1 ? da = 0 : da = 1"
                >
                  <div class="vote-card-mask" />
                  <!-- 	<div name="da" class="ball-txt">
										<div class="dz5 notranslate">{{data.sda}}</div>
									</div> -->
                  <span
                    v-if="da == 1"
                    class="vote-check"
                  />
                </li>
                <li
                  class="selit vote-card vote-card-ship"
                  :class="xiao == 1 ? 'checked' : ''"
                  :style="optionBg(data.p2)"
                  @click="xiao == 1 ? xiao = 0 : xiao = 1"
                >
                  <div class="vote-card-mask" />
                  <!-- <div name="xiao" class="ball-txt">
										<div class="dz5 notranslate">{{data.sxiao}}</div>
									</div> -->
                  <span
                    v-if="xiao == 1"
                    class="vote-check"
                  />
                </li>
                <li
                  class="selit vote-card vote-card-heart"
                  :class="dan == 1 ? 'checked' : ''"
                  :style="optionBg(data.p3)"
                  @click="dan == 1 ? dan = 0 : dan = 1"
                >
                  <div class="vote-card-mask" />
                  <!-- <div name="dan" class="ball-txt">
										<div class="dz5 notranslate">{{data.sdan}}</div>
									</div> -->
                  <span
                    v-if="dan == 1"
                    class="vote-check"
                  />
                </li>
                <li
                  class="selit vote-card vote-card-rocket"
                  :class="shuang == 1 ? 'checked' : ''"
                  :style="optionBg(data.p4)"
                  @click="shuang == 1 ? shuang = 0 : shuang = 1"
                >
                  <div class="vote-card-mask" />
                  <!-- <div name="shuang" class="ball-txt">
										<div class="dz5 notranslate">{{data.sshuang}}</div>
									</div> -->
                  <span
                    v-if="shuang == 1"
                    class="vote-check"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!historyOpen && liveVoteDisplayList.length"
        class="live-vote-panel"
      >
        <div class="live-vote-title">
          {{ $t('pro2.livevote') }}
        </div>
        <div class="live-vote-body">
          <div class="live-vote-track">
            <div
              v-for="(item, index) in liveVoteDisplayList"
              :key="index"
              class="live-vote-row"
            >
              {{ item.message }} {{ item.code }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="selectedCount() > 0"
      class="bet-sheet"
    >
      <div class="bet-title">
        {{ $t('pro2.choose') }} {{ selectedCount() }} {{ $t('pro2.vote') }} {{ selectedMoney() }} {{ $t('pro2.dot') }}
      </div>
      <div class="bet-form">
        <label>{{ $t('pro2.dot') }}:</label>
        <input
          v-model.trim="num"
          type="number"
          min="1"
          step="1000"
          class="bet-input"
        >
        <button
          type="button"
          class="rewind-btn"
          @click="resetBet"
        >
          {{ $t('pro2.rewind') }}
        </button>
      </div>
      <button
        type="button"
        class="bet-submit"
        @click="buy"
      >
        {{ $t('pro2.vote') }}
      </button>
    </div>

    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="wrapper1"
        @click.stop
      >
        <div class="block">
          <van-circle
            v-model:current-rate="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            text="Opening..."
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import {
		Progress,
		Overlay,
		Circle,
		Dialog,
		Field,
		CountDown,
		Stepper
	} from 'vant';

	Vue.use(Progress)
		.use(Overlay)
		.use(Circle)
		.use(Dialog)
		.use(Field)
		.use(CountDown)
		.use(Stepper);

	export default {
		name: "Buy",
		data() {
			return {
				show1: false,
				currentRate: 0,
				gradientColor: {
					'0%': '#ff8f00',
					'100%': '#0064d3'
				},
				data: null,
				index: 0,
				acc: null,
				show_tz: false,
				num: 0,
				da: 0,
				xiao: 0,
				dan: 0,
				shuang: 0,
				kai: null,
				items: null,
				kais: null,
				imgs: null,
				historyOpen: false,
				liveVoteList: [],
				liveVoteDisplayList: [],
				time: 5000000
			};
		},
		created() {
			this.$parent.footer('item', true);
		},
		mounted() {
			this.index = this.$router.history.current.params.code;
			this.start();
			this.accinfo();
			this.generateLiveVotes();
		},
		methods: {
			periodCode() {
				return this.data && this.data.qi ? this.data.qi : "";
			},
			toggleHistory() {
				this.historyOpen = !this.historyOpen;
			},
			optionBg(img) {
				return img ? {
					backgroundImage: "url(" + img + ")"
				} : {};
			},
			selectedCount() {
				return Number(this.da) + Number(this.xiao) + Number(this.dan) + Number(this.shuang);
			},
			selectedMoney() {
				var money = parseInt(this.num, 10);
				if (isNaN(money) || money < 0) {
					money = 0;
				}
				return this.selectedCount() * money;
			},
			resetBet() {
				this.num = 0;
			},
			historyList() {
				var list = [];
				var source = this.kais && this.kais.length ? this.kais : [];
				for (var i = 0; i < source.length; i++) {
					list.push(this.createHistoryRow(source[i], i));
				}
				if (!list.length) {
					var baseCode = parseInt(this.periodCode(), 10) || 202605214186;
					for (var j = 1; j <= 16; j++) {
						list.push(this.createHistoryRow({
							ino: baseCode - j,
							da: j % 3 === 0 ? 1 : 0,
							dan: j % 4 === 0 ? 0 : 1
						}, j));
					}
				}
				return list;
			},
			createHistoryRow(item, index) {
				var first = parseInt(item.da, 10) === 1 ? this.data.sxiao : this.data.sda;
				var second = parseInt(item.dan, 10) === 1 ? this.data.sshuang : this.data.sdan;
				return {
					code: item.ino || item.qi || item.id || (parseInt(this.periodCode(), 10) - index - 1),
					first: first || "",
					second: second || ""
				};
			},
			generateLiveVotes() {
				var messages = [
					this.$t('pro2.voteMsgFirst'),
					this.$t('pro2.voteMsgSecond'),
					this.$t('pro2.voteMsgFirstDone'),
					this.$t('pro2.voteMsgSecondDone'),
					this.$t('pro2.voteMsgFirst')
				];
				var list = [];
				for (var i = 0; i < 12; i++) {
					list.push({
						message: messages[Math.floor(Math.random() * messages.length)],
						code: this.createVoteCode(i)
					});
				}
				this.liveVoteList = list;
				this.liveVoteDisplayList = list.concat(list);
			},
			createVoteCode(index) {
				var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
				var first = letters[(index + Math.floor(Math.random() * letters.length)) % letters.length];
				var second = letters[Math.floor(Math.random() * letters.length)];
				var num = Math.floor(Math.random() * 9) + 1;
				return first + "****" + num + second;
			},
			graptime(randomInt) {
				this.currentRate += randomInt;
				if (this.currentRate < 100) {
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				} else {
					this.show1 = false;
					this.start();
					this.accinfo();
				}
			},
			finish() {
				this.show1 = true;
				var randomInt = Math.floor(Math.random() * 20) + 10;
				this.currentRate = 0;
				this.graptime(randomInt);
			},
			accinfo() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
				});
			},
			maxnum() {
				// this.number = this.data.max;
			},
			start() {
				Fetch('/index/item_detail', {
					id: this.index
				}).then(res => {
					this.data = res.data;
					this.vip = res.data.vip;
					this.kais = res.data.kais;
					if (this.kais) {
						this.kai = this.kais[0];
					}
				});
				Fetch('/index/itemslist').then(res => {
					this.items = res.data;
				});
			},
			buy() {
				var amount = this.da + this.xiao + this.dan + this.shuang;
				if (amount == 0) {
					this.$toast(this.$t('pro.seltype'));
					return false;
				}
				if (this.num < 1) {
					this.$toast(this.$t('pro.minmoney0'));
					return false;
				}
				amount = amount * this.num;
				if (amount > this.acc.money) {
					this.$toast(this.$t('pro.insufficient'));
					return false;
				}
				Dialog.confirm({
					title: '',
					confirmButtonText: this.$t('utils.confirm'),
					cancelButtonText: this.$t('utils.cancel'),
					message: this.$t('pro.issubmit')
				}).then(() => {
					Fetch("/user/item_buy", {
						id: this.data.id,
						money: this.num,
						da: this.da,
						xiao: this.xiao,
						dan: this.dan,
						shuang: this.shuang
					}).then(r => {
						if (r.data && r.data > 0) {
							this.$router.push("/invest");
						} else {
							this.$router.push("/order");
						}
					}).catch(err => {
						console.log(err);
					});
				}).catch(() => {});
			}
		}
	};
</script>

<style lang="less" scoped>
	.basic_wrap {
		min-height: 100vh;
		overflow-x: hidden;
		background: #fff;
		padding-bottom: 24px;
		color: #10243c;
	}

	.basic_wrap.has-bet-sheet {
		padding-bottom: 300px;
	}

	.red_top_bg {
		position: relative;
		width: 100%;
		height: 50px;
		background: #fff;
		border-bottom: 1px solid #eee;
		box-sizing: border-box;
	}

	.page-back {
		position: absolute;
		left: 14px;
		top: 15px;
		color: #cfd3d8;
		font-size: 28px;
	}

	.product {
		width: 100%;
		box-sizing: border-box;
	}

	.period-card {
		margin: 2%;
		padding: 22px 15px 15px;
		border-radius: 12px 12px 0 0;
		background: linear-gradient(120deg, #ff7f9b 0%, #ff426b 100%);
		color: #fff;
		box-sizing: border-box;
	}

	.period-row {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.period-label {
		font-size: 14px;
		line-height: 24px;
		font-weight: 600;
	}

	.period-status {
		margin-top: 12px;
		font-size: 14px;
		line-height: 24px;
		font-weight: 400;
		white-space: normal;
	}

	.period-status strong {
		font-weight: 700;
	}

	.period-time {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 64px;
		height: 32px;
		margin-top: 24px;
		padding: 0 8px;
		border: 1px solid rgba(255, 255, 255, .75);
		border-radius: 4px;
		color: #fff;
		font-size: 14px;
		box-sizing: border-box;
	}

	.period-time /deep/ .van-count-down {
		color: #fff;
		font-size: 14px;
		line-height: 32px;
	}

	.period-menu {
		width: 30px;
		padding-top: 2px;
		cursor: pointer;
	}

	.period-menu span {
		display: block;
		width: 28px;
		height: 4px;
		margin-bottom: 4px;
		border-radius: 4px;
		background: #fff;
	}

	.period-bottom {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 26px;
		font-size: 14px;
		line-height: 24px;
	}

	.period-bottom strong {
		font-weight: 700;
	}

	.history-toggle {
		display: flex;
		align-items: center;
		gap: 5px;
		font-weight: 600;
		cursor: pointer;
	}

	.history-board {
		margin: 0 14px;
		color: #555cf2;
		font-size: 14px;
		font-weight: 700;
		line-height: 1.35;
	}

	.history-head,
	.history-row {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 36px;
		font-weight: normal;
	}

	.history-head {
		margin-bottom: 14px;
		font-size: 14px;
		font-weight: bold;
	}

	.history-row {
		margin-bottom: 12px;
	}

	.history-row div:last-child {
		display: flex;
		gap: 24px;
	}

	.main {
		padding: 0 2%;
		box-sizing: border-box;
	}

	.com-k3selector {
		width: 100%;
	}

	.MethodWrap {
		padding: 10px 0 0;
		background: #fff;
		box-sizing: border-box;
	}

	.MethodTitle {
		position: relative;
		margin-bottom: 22px;
		padding-left: 18px;
		font-size: 14px;
		font-weight: 400;
		line-height: 26px;
		color: #14273c;
	}

	.MethodTitle:before {
		content: "";
		position: absolute;
		top: 1px;
		left: 0;
		width: 6px;
		height: 24px;
		border-radius: 4px;
		background: #5b60e9;
	}

	.Method ul {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 24px 24px;
		padding: 0;
		margin: 0;
		list-style: none;
	}

	.vote-card {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 126px;
		border-radius: 6px;
		background-color: #f2f2f2;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		box-shadow: 0 2px 7px rgba(0, 0, 0, .16);
		cursor: pointer;
		overflow: hidden;
	}

	.vote-card-mask {
		position: absolute;
		inset: 0;
		background: rgba(255, 255, 255, .04);
		transition: background .2s ease;
	}

	.vote-card.checked .vote-card-mask {
		background: rgba(83, 78, 202, .5);
	}

	.ball-txt {
		position: relative;
		z-index: 2;
		max-width: 92%;
		color: #ff5ab1;
		font-size: 39px;
		font-weight: 700;
		line-height: 1;
		text-align: center;
		text-shadow:
			-1px -1px 0 #fff,
			1px -1px 0 #fff,
			-1px 1px 0 #fff,
			1px 1px 0 #fff,
			0 2px 5px rgba(94, 75, 180, .55);
		word-break: break-word;
	}

	.vote-check {
		position: absolute;
		z-index: 3;
		left: 50%;
		top: 50%;
		width: 20px;
		height: 11px;
		margin: -5px 0 0 -10px;
		border-left: 5px solid #fff;
		border-bottom: 5px solid #fff;
		transform: rotate(-45deg);
		filter: drop-shadow(0 1px 2px rgba(50, 47, 145, .45));
	}

	.live-vote-panel {
		margin: 32px 2% 20px;
		overflow: hidden;
		border: 1px solid #6464ff;
		border-radius: 14px;
		background: #fff;
	}

	.live-vote-title {
		height: 60px;
		line-height: 60px;
		text-align: center;
		background: #5b5ce2;
		color: #fff;
		font-size: 14px;
		font-weight: 700;
	}

	.live-vote-body {
		height: 392px;
		overflow: hidden;
	}

	.live-vote-track {
		animation: liveVoteScroll 18s linear infinite;
	}

	.live-vote-row {
		background: #fff;
		min-height: 50px;
		padding: 10px 2%;
		box-sizing: border-box;
		color: #3d4655;
		font-size: 12px;
		line-height: 30px;
	}

	.live-vote-row:nth-child(even) {
		background: #eee;
	}

	.bet-sheet {
		position: fixed;
		left: 50%;
		bottom: 0;
		z-index: 30;
		width: 100%;
		max-width: 600px;
		padding: 26px 18px 100px;
		border-radius: 18px 18px 0 0;
		background: #fff;
		box-shadow: 0 -2px 10px rgba(0, 0, 0, .12);
		box-sizing: border-box;
		transform: translateX(-50%);
	}

	.bet-title {
		color: #5960f1;
		font-size: 14px;
		font-weight: bold;
		line-height: 30px;
	}

	.bet-form {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top:30px;
	}

	.bet-form label {
		margin-right: 8px;
		color: #5960f1;
		font-size: 14px;
		font-weight: bold;
	}

	.bet-input {
		width: 200px;
		height: 38px;
		padding: 0 16px;
		border: none;
		border-radius: 26px;
		background: #eee;
		box-sizing: border-box;
		color: #ff2638;
		font-size: 18px;
		outline: none;
	}

	.rewind-btn {
		height: 38px;
		margin-left: 12px;
		padding: 0 14px;
		border: none;
		border-radius: 30px;
		background: #eee;
		color: #aaa;
		font-size: 14px;
	}

	.bet-submit {
		display: block;
		width: 76%;
		height: 38px;
		margin: 30px auto 0;
		border: none;
		border-radius: 6px;
		background: #5b5ce2;
		color: #fff;
		font-size: 14px;
		font-weight: 600;
	}

	.wrapper1 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
	}

	.block {
		width: 120px;
		height: 120px;
	}

	/deep/ .van-circle__text {
		color: #fff;
	}

	@keyframes liveVoteScroll {
		0% {
			transform: translateY(0);
		}

		100% {
			transform: translateY(-50%);
		}
	}

	@media (max-width: 420px) {
		.period-card {
			margin: 2%;
			padding: 22px 15px 15px;
		}

		.period-status,
		.period-bottom,
		.period-time /deep/ .van-count-down {
			font-size: 14px;
		}

		.main {
			padding: 0 23px;
		}

		.Method ul {
			gap: 24px 24px;
		}

		.vote-card {
			height: 126px;
		}

		.ball-txt {
			font-size: 39px;
		}

		.live-vote-panel {
			margin-right: 24px;
			margin-left: 24px;
		}

		.bet-input {
			width: 260px;
		}
	}

	@media (max-width: 360px) {
		.Method ul {
			gap: 18px 18px;
		}

		.vote-card {
			height: 112px;
		}

		.ball-txt {
			font-size: 32px;
		}

		.bet-input {
			width: 190px;
		}
	}
</style>
